
import React from 'react';
import { Box, Text } from 'grommet';

const Message = ({text}) => {
    return (
        <Box pad="32px" background="light-2" direction="row" gap="32px">
            <Text>{text}</Text>
        </Box>
    );
};

export default Message;
